import React from 'react';
import './BrushSlider.css';

const BrushSlider = ({ brushsize, setBrushsize, color, toolType, top }) => {
  const isErase = toolType === 'erase';
  const background = isErase ? 'url(/img/stripe-pattern.svg) white' : color;
  return (
    <div
      className="brush-slider"
      style={{
        '--brush-size': `${brushsize}px`,
        '--brush-background': background,
        transform: `translateY(${top + 8}px)`,
      }}
    >
      <input
        type="range"
        className="brush-size"
        min="10"
        max="50"
        value={brushsize}
        onChange={(e) => setBrushsize(e.target.value)}
      />
    </div>
  );
};

export default BrushSlider;
